export const home = "/user-guides";
export const userGuidePath = (app, slug) => `${home}/${app.toLowerCase()}${slug ? "/" + slug : ""}`;
